module.exports = __webpack_public_path__ + "static/media/157.b5f45db0.png";